import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-qavisitaudit",
  templateUrl: "./qavisitaudit.component.html",
  styleUrls: ["./qavisitaudit.component.scss"],
})
export class QavisitauditComponent implements OnInit {
  title: string = "مراجعة تقارير الجودة";
  constructor() {}

  ngOnInit() {}
}
